var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vendor-store"}},[_c('div',{staticClass:"actions"},[_c('LayoutCentered',{staticClass:"layout"},[(_vm.gridView)?_c('VendorStoreGridView'):_vm._e(),(_vm.displayListView)?_c('VendorStoreListView'):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }